<template>
  <v-col cols="12" class="my-0 py-0">
    <v-dialog :value="dialog" max-width="600px" v-if="$vuetify.breakpoint.smAndDown">
      <v-card class="d-flex flex-row flex-wrap justify-space-around py-5">
        <v-card-title>
          <h3>Filter By</h3>
        </v-card-title>
        <v-card-text>
          <div>
            <v-combobox
                v-model="filteredGrade"
                :disabled="loading"
                :items="grades"
                :search-input.sync="search"
                chips
                deletable-chips
                item-text="grade"
                item-value="id"
                label="Select Grades"
                solo
                outlined
                flat
                return-object
            >
              <template v-slot:[`item.name`]="{ item }">
                <div class="p-2">
                  {{ item.grade }}
                </div>
              </template>
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-if="search">
                      No grade matching "<strong>{{ search }}</strong>"
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      No grades to select
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </div>
          <div>
            <v-combobox
                    v-model="filteredSubject"
                    :disabled="loading"
                    :items="subjects"
                    :search-input.sync="search"
                    chips
                    deletable-chips
                    item-text="name"
                    item-value="id"
                    label="Select Subjects"

                    solo
                    outlined
                    flat
                    return-object
                >
                  <template v-slot:[`item.name`]="{ item }">
                    <div class="p-2">
                      {{ item.name }}
                    </div>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title v-if="search">
                          No subject matching "<strong>{{ search }}</strong>"
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          No subjects to select
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
          </div>
          <div>
            <v-combobox
                    v-model="filteredTopic"
                    :disabled="loading"
                    :items="topics"
                    :search-input.sync="search"
                    chips
                    deletable-chips
                    item-text="title"
                    item-value="id"
                    label="Select Topics"
                    solo
                    outlined
                    flat
                    return-object
                >
                  <template v-slot:[`item.name`]="{ item }">
                    <div class="p-2">
                      {{ item.title }}
                    </div>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title v-if="search">
                          No topic matching "<strong>{{ search }}</strong>"
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          No topics to select
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
          </div>
          <div>
            <v-combobox
                    v-model="filteredYear"
                    :disabled="loading"
                    :items="years"
                    :search-input.sync="search"
                    chips
                    deletable-chips
                    label="Select Years"
                    solo
                    outlined
                    flat
                    return-object
                >
                  <template v-slot:[`item.name`]="{ item }">
                    <div class="p-2">
                      {{ item }}
                    </div>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title v-if="search">
                          No year matching "<strong>{{ search }}</strong>"
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          No years to select
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
              @click="applyFilters()"
              elevation="0"
              height="3.3em"
              color="primary"
              :disabled="!(filteredGrade || filteredSubject || filteredTopic || filteredYear)"
          >
            Apply Filters
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row v-else>
      <v-col cols="2">
        <v-combobox
            v-model="filteredGrade"
            :disabled="loading"
            :items="grades"
            :search-input.sync="search"
            chips
            deletable-chips
            item-text="grade"
            item-value="id"
            label="Select Grades"
            solo
            flat
            return-object
        >
          <template v-slot:[`item.name`]="{ item }">
            <div class="p-2">
              {{ item.grade }}
            </div>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-if="search">
                  No grade matching "<strong>{{ search }}</strong>"
                </v-list-item-title>
                <v-list-item-title v-else>
                  No grades to select
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="3">
        <v-combobox
            v-model="filteredSubject"
            :disabled="loading"
            :items="subjects"
            :search-input.sync="search"
            chips
            deletable-chips
            item-text="name"
            item-value="id"
            label="Select Subjects"
            solo
            flat
            return-object
        >
          <template v-slot:[`item.name`]="{ item }">
            <div class="p-2">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-if="search">
                  No subject matching "<strong>{{ search }}</strong>"
                </v-list-item-title>
                <v-list-item-title v-else>
                  No subjects to select
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="3">
        <v-combobox
            v-model="filteredTopic"
            :disabled="loading"
            :items="topics"
            :search-input.sync="search"
            chips
            deletable-chips
            item-text="title"
            item-value="id"
            label="Select Topics"
            solo
            flat
            return-object
        >
          <template v-slot:[`item.name`]="{ item }">
            <div class="p-2">
              {{ item.title }}
            </div>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-if="search">
                  No topic matching "<strong>{{ search }}</strong>"
                </v-list-item-title>
                <v-list-item-title v-else>
                  No topics to select
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
            v-model="filteredYear"
            :disabled="loading"
            :items="years"
            :search-input.sync="search"
            chips
            deletable-chips
            label="Select Years"
            solo
            flat
            return-object
        >
          <template v-slot:[`item.name`]="{ item }">
            <div class="p-2">
              {{ item }}
            </div>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-if="search">
                  No year matching "<strong>{{ search }}</strong>"
                </v-list-item-title>
                <v-list-item-title v-else>
                  No years to select
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="1" class="d-flex flex-row justify-space-between">
        <v-btn
            @click="applyFilters()"
            elevation="0"
            height="3.3em"
            color="primary"
            :disabled="!(filteredGrade || filteredSubject || filteredTopic || filteredYear)"
        >
          Apply Filters
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import {generateYearsBetween} from "@/utilz/date";

export default {
  name: "GradeSubjectTopicFilters",
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      search: "",
      grades: [],
      subjects: [],
      topics: [],
      years: [],
      filteredGrade: null,
      filteredSubject: null,
      filteredTopic: null,
      filteredYear: null,
    }
  },
  async mounted() {
    const { data } = await this.axios.get("class_grade/?country_code=UG&limit=100");
    this.grades = data.results;
    this.years = generateYearsBetween(2022,2000)
  },
  watch: {
    async filteredGrade(val) {
      this.filteredSubject = null
      if(!val) {
        this.subjects = []
        this.$emit("clearFilters")
        return
      }
      const { data } = await this.axios.get(`subjects/?grade=${val.id}&limit=100`);
      this.subjects = [...data.results]
    },
    async filteredSubject(val) {
      this.filteredTopic = null
      if(!val) {
        this.topics = []
        return
      }
      const { data } = await this.axios.get(`topics/?grade_level=${this.filteredGrade.id}&subject=${val.id}&limit=100`);
      this.topics = [...data.results]
    },
  },
  methods: {
    applyFilters() {
      this.$emit("applyFilters", {
        grade: this.filteredGrade || {},
        subject: this.filteredSubject || {},
        topic: this.filteredTopic || {},
        year: this.filteredYear
      })
    }
  }
}
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
  font-family: Montserrat, sans-serif;
}
</style>
